import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'arrow-down', 'ArrowDown', [["path",{"d":"M12 5l0 14"}],["path",{"d":"M18 13l-6 6"}],["path",{"d":"M6 13l6 6"}]]);